export enum CloudColorNames {
  deals = "deals",
  primary = "primary",
  secondary = "secondary",
}

export type TColors = Record<CloudColorNames, string>;
